import React from 'react';
import EmptyTable from 'assets/icons/empty-tables.svg';

const EmptyState = () => {
  return (
    <div className='grid place-items-center mt-32'>
      <img src={EmptyTable} alt='' />
      <p className='text-gray-5'>You haven’t created any tables</p>
    </div>
  );
};

export default EmptyState;
